import { getRating } from '@/shared/api/rating';
import { useSentryAsync } from '@/shared/composition/useSentryAsync';
import { defineStore } from 'pinia';

const { captureExceptionSentry } = useSentryAsync();

export const useRatingStore = defineStore('rating', {
  state: () => ({
    client: null as any,
    error: null as any,
    top: null as any,
  }),
  actions: {
    async fetchRating() {
      try {
        const { client, top } = await getRating();

        if (client) {
          this.client = client;
        }

        if (top) {
          this.top = top;
        }
      } catch (error) {
        captureExceptionSentry(error, 'получение рейтинга');
        this.error = error;
      }
    },
  },
});
